import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import http from "../../common/http-common";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";

const _pageName = "SystemInfoActivator.js";

const SystemInfoActivator = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //#region Event Handlers
  //#region Modal Show/Hide
  const hideModal = () => {
    props.onHide();
  };
  //#endregion

  //#region Confirm Update Status
  const confirmBtnOnClick = () => {
    UpdateSystemStatus(props.editData);
  };

  const UpdateSystemStatus = (_data) => {
    let functionName = "";

    try {
      functionName = _pageName + UpdateSystemStatus.name;

      props.onLoading(
        true,
        (_data.ACTIVE_FLAG === "Y" ? "Deactivating" : "Activating") +
          " System, please wait...",
      );
      props.onHide();

      const data = {
        ORG_SYSTEM_DETAILS_ID: _data.ORG_SYSTEM_DETAILS_ID,
        ORG_SYSTEM_ID: _data.ORG_SYSTEM_ID,
        ORG_ID: _data.ORG_ID,
        SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
        ACTIVE_FLAG: _data.ACTIVE_FLAG,
        REMARK: _data.REMARK || "",
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
      };
//console.log(data);
      http
        .put("api/SystemInfo/UpdateSysStatus", data, { timeout: 5000 })
        .then((response) => {
          const successAction =
            _data.ACTIVE_FLAG === "Y" ? "deactivated" : "activated";
          toast.success("System is successfully " + successAction + ".");
          props.onReload();
        })
        .catch((err) => {
          const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
          toast.error("Failed to " + action + " System. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
      toast.error("Failed to " + action + " model. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const message = (
    <>
      Confirm to{" "}
      {props.editData !== null && props.editData.ACTIVE_FLAG === "Y"
        ? "deactivate"
        : "activate"}
      ? <br /> System:{" "}
      {<b> {props.editData !== null && props.editData.SYSTEM_MST_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        onHide={hideModal}
        onConfirm={confirmBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default SystemInfoActivator;

